export default __webpack_public_path__ + "static/media/nextIcon.6601a1e8.svg";